import React, { useState } from "react";
import {
  Box,
  Button,
  MenuItem,
  Paper,
  Select,
  TextField,
  Typography,
} from "@mui/material";
import DocumentSelectorModal from "./DocumentSelectorModal";

export default function DebitNoteInfo({
  persona,
  documentoRelacionadoId,
  documentoRelacionadoNumero,
  documentoRelacionadoClaveAcceso,
  tipoNotaDebito,
  motivo,
  onDocumentSelected,
  onChange,
  mobile = false,
}) {
  const [open, setOpen] = useState(false);

  const hasDocument = Boolean(documentoRelacionadoId);

  const handleTipoChange = (e) => {
    onChange?.({
      tipo_nota_debito: e.target.value,
    });
  };

  const handleMotivoChange = (e) => {
    const value = e.target.value;

    onChange?.({
      motivo_nota_debito: value,
      nota_debito_motivo: value,
      descripcion_factura: value,
    });
  };

  return (
    <Box sx={{ width: "100%" }}>
      <Paper
        sx={{
          p: mobile ? 1.5 : 2,
          border: "1px solid #e0e0e0",
          borderRadius: 2,
          bgcolor: "#fafafa",
        }}
      >
        <Typography sx={{ fontWeight: 800, color: "#333", mb: 1 }}>
          Documento relacionado
        </Typography>

        <Button
          variant="contained"
          onClick={() => setOpen(true)}
          sx={{ bgcolor: "#1565C0", mb: 1.5 }}
          fullWidth={mobile}
        >
          Seleccionar factura
        </Button>

        {hasDocument ? (
          <Box sx={{ display: "flex", flexDirection: "column", gap: 1 }}>
            <TextField
              label="Factura relacionada"
              value={documentoRelacionadoNumero || ""}
              InputProps={{ readOnly: true }}
              fullWidth={mobile}
              sx={{ minWidth: mobile ? "100%" : 350 }}
            />
            <TextField
              label="Clave de acceso"
              value={documentoRelacionadoClaveAcceso || ""}
              InputProps={{ readOnly: true }}
              fullWidth
            />
          </Box>
        ) : (
          <Typography sx={{ fontSize: 13, color: "#777" }}>
            Selecciona la factura autorizada sobre la que se emitirá la nota de débito.
          </Typography>
        )}

        <Box sx={{ mt: 2 }}>
          <Typography sx={{ fontWeight: 700, color: "#333", mb: 0.75 }}>
            Tipo de nota de débito
          </Typography>

          <Select
            value={tipoNotaDebito || "OTROS"}
            onChange={handleTipoChange}
            fullWidth={mobile}
            sx={{ minWidth: mobile ? "100%" : 280 }}
          >
            <MenuItem value="INTERESES">Intereses</MenuItem>
            <MenuItem value="GASTOS">Gastos</MenuItem>
            <MenuItem value="AJUSTE_PRECIO">Ajuste de precio</MenuItem>
            <MenuItem value="OTROS">Otros</MenuItem>
          </Select>
        </Box>

        <Box sx={{ mt: 2 }}>
          <TextField
            label="Motivo de la nota de débito"
            value={motivo || ""}
            onChange={handleMotivoChange}
            multiline
            minRows={2}
            fullWidth
          />
        </Box>
      </Paper>

      <DocumentSelectorModal
        open={open}
        onClose={() => setOpen(false)}
        persona={persona}
        title="Seleccionar factura para nota de débito"
        tipo="FACTURA"
        endpoint="/facturas/documentos-relacionados/facturas-cliente/"
        detailEndpoint="/facturas/documentos-relacionados/detalle-factura/"
        onSelected={onDocumentSelected}
      />
    </Box>
  );
}